/**
 * Clase que contiene la información de seguridad de un usuario
 */
export interface IdentityUser {
  /** Nombre de usuario */
  userName: string;
  /** Nombre completo del usuario */
  fullName: string;
  /** Menu al que el usuario tiene acceso */
  menu: string; //MenuHeader;
  /** Ultima vez que el usuario accedió al sistema */
  lastAccess: string;
  /** Url para hacer logout parcial */
  urlLogout: string;
  /** Url para hacer logout completo (elimina el single-sign-on del usuario) */
  fullUrlLogout: string;
}
